import { initColorSwitch, initSizesScroll, initSizeSelect } from '../productCard.ts';

initSizesScroll();
initColorSwitch();
initSizeSelect();
